import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (

    <>

     <section id="discover-niketion" className="discover-niketion-aera background-color-com jarallax pt-130 pb-130">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="discover-niketion-text">
                        <h2>Join Today. Get the World in Your Palm</h2>
                        <p>
                            Come, be a part of India's most exclusive business chamber
                        </p>
                       

                        <Link to="/BusinessLeagueModel" className="btn-m3">
                       The Business League Model
                       </Link>
                    </div>
                </div>
            </div>
        </div>
    </section>



     <footer className="footer-area">
     
        <div className="copy-right-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="copy-right-text">
                            <p className="text-center"> 2025 © Copyrights  121 Bharat Business Tycoon Chamber. All rights reserved.</p>
                        </div>
                    </div>
                 
                </div>
            </div>
        </div>
    </footer>


     <a href="#" className="scroll-top show" id="scroll-top">
        <i className="arrow-top fal fa-long-arrow-up"></i>
        <i className="arrow-bottom fal fa-long-arrow-up"></i>
    </a>

    </>


      );
}

export default Footer;